exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-Tabs-___style__container___3BTtP {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  overflow: hidden; }\n\n.src-components-Tabs-___style__tabs___N3ued {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  color: #aaa;\n  margin: 0 20px; }\n  .src-components-Tabs-___style__tabs___N3ued .src-components-Tabs-___style__tab___37Knu {\n    padding: 8px 4px;\n    margin: 12px 10px;\n    cursor: pointer;\n    color: #5D5D5D; }\n    .src-components-Tabs-___style__tabs___N3ued .src-components-Tabs-___style__tab___37Knu.src-components-Tabs-___style__active___2XgDr {\n      font-weight: 900;\n      border-bottom: 2px solid #5D5D5D; }\n\n.src-components-Tabs-___style__content___3ntvZ {\n  position: relative;\n  height: calc(100% - 61px);\n  overflow: auto; }\n", ""]);

// exports
exports.locals = {
	"container": "src-components-Tabs-___style__container___3BTtP",
	"tabs": "src-components-Tabs-___style__tabs___N3ued",
	"tab": "src-components-Tabs-___style__tab___37Knu",
	"active": "src-components-Tabs-___style__active___2XgDr",
	"content": "src-components-Tabs-___style__content___3ntvZ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./node_modules","./node_modules/grommet/node_modules"]}!./src/components/Tabs/style.scss
// module id = 438
// module chunks = 0